import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { take, filter, switchMap, map } from 'rxjs/operators';
import { getOneClickVehicles } from '@ordersnproducts/modules/one-click-order/selectors/one-click-vehicles.selector';
import { OneClickSelectVehicleAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-vehicles.actions';

@Injectable()
export class OneClickSetVehicle implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store
        .select(getOneClickVehicles)
        .pipe(
          filter((vehicles) => !!vehicles.length),
          take(1),
          map((vehicles) => vehicles.find((item) => item.vehicleId === value)),
          switchMap((vehicle) =>
            this.store.select(getOneClickSelectedOrder).pipe(
              take(1),
              map((order) => ({ order, vehicle })),
            ),
          ),
        )
        .subscribe(({ order, vehicle }) => {
          const orderUpdated = {
            ...order,
            items: order.items.map((item, index) => {
              if (index === form.mapItem['index']) {
                return {
                  ...item,
                  shippingVehicle: {
                    shippingVehicleId: vehicle.vehicleId,
                    shippingVehicleCode: vehicle.vehicleCode,
                    shippingVehicleDesc: vehicle.vehicleDesc,
                  },
                };
              } else {
                return item;
              }
            }),
          } as Order;
          this.store.dispatch(new OneClickSelectVehicleAction(vehicle));
          this.store.dispatch(new OneClickUpdateOrderAction(orderUpdated));
        });
    }
  }
}
